export enum LandingPageTextKeys {
  IntroBlockTitle = 'aff.intro.title',
  IntroBlockDescription = 'aff.intro.description',
  IntroBlockButton = 'aff.intro.button',
  IntroBlockLabel = 'aff.intro.label',
  IntroBlockButtonLogIn = 'aff.intro.login_button.text',

  WhatUpBlockTitle = 'aff.whatup.title',
  WhatUpBlockCard0Title = 'aff.whatup.card0.title',
  WhatUpBlockCard0Description = 'aff.whatup.card0.description',
  WhatUpBlockCard1Title = 'aff.whatup.card1.title',
  WhatUpBlockCard1Description = 'aff.whatup.card1.description',
  WhatUpBlockCard2Title = 'aff.whatup.card2.title',
  WhatUpBlockCard2Description = 'aff.whatup.card2.description',

  HowItWorkBlockTitle = 'aff.howitwork.title',
  HowItWorkBlockCard0Title = 'aff.howitwork.card0.title',
  HowItWorkBlockCard0Description = 'aff.howitwork.card0.description',
  HowItWorkBlockCard1Title = 'aff.howitwork.card1.title',
  HowItWorkBlockCard1Description = 'aff.howitwork.card1.description',
  HowItWorkBlockCard2Title = 'aff.howitwork.card2.title',
  HowItWorkBlockCard2Description = 'aff.howitwork.card2.description',
  HowItWorkBlockGraphTitle = 'aff.howitwork.graph.title',
  HowItWorkBlockGraphColumn0 = 'aff.howitwork.graph.column0',
  HowItWorkBlockGraphColumn1 = 'aff.howitwork.graph.column1',
  HowItWorkBlockContentTitle = 'aff.howitwork.content.title',
  HowItWorkBlockContactUs = 'aff.howitwork.contactus',
  HowItWorkBlockButton = 'aff.howitwork.button',

  PersonalBlockHeader = 'aff.personal.header',
  PersonalBlockTitle = 'aff.personal.title',
  PersonalBlockDescription = 'aff.personal.description',
  PersonalBlockCard0Title = 'aff.personal.card0.title',
  PersonalBlockCard0Description = 'aff.personal.card0.description',
  PersonalBlockCard1Title = 'aff.personal.card1.title',
  PersonalBlockCard1Description = 'aff.personal.card1.description',
  PersonalBlockCard2Title = 'aff.personal.card2.title',
  PersonalBlockCard2Description = 'aff.personal.card2.description',
  PersonalBlockCard3Title = 'aff.personal.card3.title',
  PersonalBlockCard3Description = 'aff.personal.card3.description',

  TrustUsBlockTitle = 'aff.trustus.title',
  TrustUsBlockDescription = 'aff.trustus.description',
  TrustUsBlockButton = 'aff.trustus.button',
  TrustUsBlockFeature0 = 'aff.trustus.feature0',
  TrustUsBlockFeature1 = 'aff.trustus.feature1',
  TrustUsBlockFeature2 = 'aff.trustus.feature2',
  TrustUsBlockCard0Description = 'aff.trustus.card0.description',
  TrustUsBlockCard1Description = 'aff.trustus.card1.description',
  TrustUsBlockCard2Description = 'aff.trustus.card2.description',
  TrustUsBlockCard3Description = 'aff.trustus.card3.description',

  DoctorsBlockTitle = 'aff.doctors.title',
  DoctorsBlockLabel = 'aff.doctors.label',

  JoinBlockTitle = 'aff.join.title',
  JoinBlockDescription = 'aff.join.description',
  JoinBlockButton = 'aff.join.button',

  FooterAddress = 'aff.footer.address',
  FooterDisclaimer = 'aff.footer.disclaimer',
  FooterTermsOfUse = 'aff.footer.termsofuse',
  FooterPrivacyPolicy = 'aff.footer.privacypolicy',

  LocaleModalTitle = 'aff.lp.locale.modal.title',
}

export enum LandingPageLinkKeys {
  MainLink = 'aff.link.main',
  AffiliatesLink = 'aff.link.affiliates',
  TermsOfUseLink = 'aff.link.termsofuse',
  PrivacyPolicyLink = 'aff.link.privacypolicy',
  LearnMoreLink = 'aff.link.security',
  HowItWorkBlockMailTo = 'aff.howitwork.mailto',
  IntroBlockUrlLogIn = 'aff.intro.login_button.url',
}

export enum LandingPageImageKeys {
  IntroBlockPersonImage = 'aff.intro.person.image',

  WhatUpBlockCard0Image = 'aff.whatup.card0.image',
  WhatUpBlockCard1Image = 'aff.whatup.card1.image',
  WhatUpBlockCard2Image = 'aff.whatup.card2.image',

  JoinBlockBackground = 'aff.join.background',
}

export enum LandingPageContentKeys {
  HowItWorkBlockContent = 'aff.howitwork.content',
  DoctorsBlockContent = 'aff.doctors.content',
  UserReviewsBlockContent = 'aff.reviews.content',
  PersonalBlockContent = 'aff.personal.content',
  FAQBlockContent = 'aff.faq.content',
}

export enum LandingPageJsonKeys {
  GraphJson = 'aff.howitwork.graph',
}
